(function () {
    'use strict';

    function crmRouteConfig($stateProvider) {

        $stateProvider
            .state('entitydashboard', {
                url: '/crm/accounts/dashboard/*entityId',
                controller: 'crmController',
                controllerAs: 'ctrl'
            })
            .state('entityaccountmanagers', {
                url: '/crm/accounts/accountmanagers/*entityId',
                controller: 'assignAccountManagersToContractorController',
                controllerAs: 'ctrl'
            })
            .state('entityprojectopportunities', {
                url: '/crm/projectopportunities/*projectId',
                controller: 'projectOpportunityEditorController',
                controllerAs: 'editor',
                templateUrl: 'crm/templates/projectOpportunityEditor.html',
                resolve: {
                    findAnEntityOptions: function () {
                        return {
                            canChoosePartnerType: true,
                            canChooseEntityType: true,
                            defaultEntityType: 'Contractors'
                        }
                    }
                }
            })
            .state('crmaccountdetails', {
                url: '/crm/accounts/details/*entityId',
                controller: 'editEntityController',
                controllerAs: 'dashboardCtrl',
                templateUrl: 'crm/templates/editEntityProfile.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    profile: [
                        "myProfileDataService", "$stateParams", function(myProfileDataService, $stateParams) {
                            return myProfileDataService.loadEntityProfile($stateParams.entityId).then(function(data) {
                                data.Attributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                data.AdminAttributes.forEach(function(attribute) {
                                    attribute.Mode = 'Editor';
                                });
                                return data;
                            });
                        }
                    ],
                    entityAdminEdits: [
                        "entityAdminEditsDataService", "profile", "$stateParams",
                        function(entityAdminEditsDataService, profile, $stateParams)
                        {
                            if (profile.CanAccessAdminEdits)
                            {
                                return entityAdminEditsDataService.loadAdminEntityEdits($stateParams.entityId).then(function (data){
                                    return data;
                                })
                            }
                        }
                    ],
                    entityId: [
                        "$stateParams", function($stateParams) {
                            return $stateParams.entityId;
                        }
                    ],
                    dashboardActivities: [
                        "dashboardActivityOptionsDataService", "$stateParams", function (dashboardActivityOptionsDataService, $stateParams) {
                            return dashboardActivityOptionsDataService.getDashboardActivityOptionsForEntity(
                                 $stateParams.entityId
                            ).then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('crmaccountcreate', {
                url: '/crm/accounts/create/:entityType',
                controller: 'createEntityController',
                controllerAs: 'createEntityCtrl',
                templateUrl: 'crm/templates/createEntity.html',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    platformEntityTypes: [
                        "createEntityTypesDataService", function(createEntityTypesDataService) {
                            return createEntityTypesDataService.getCreatePlatformEntityTypes().then(function (data) {
                                return data;
                            })
                        }
                    ]
                }
            });
    };

    crmRouteConfig.$inject = ['$stateProvider'];

    angular.module('ecap.crm').config(crmRouteConfig);
})();